import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

/** People now lives on the school setup page under the People tab. */
export default function SchoolPeoplePage() {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/admin/${slug}?tab=people`, { replace: true });
  }, [slug, navigate]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-10 text-center text-ink/60">
      Opening people…
    </div>
  );
}
